module.exports = __webpack_public_path__ + "static/media/listen_left.a7a831c6.png";